import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import Centered from "./Centered";
import Empty from "./Empty";
import MainLayout from "./MainLayout";

const Layout = ({ children, isAuthenticated }) => {
  let location = useLocation();
  let { pathname } = { ...location };

  if (["/error-page"].includes(pathname)) {
    return <Empty>{children}</Empty>;
  }
  if (isAuthenticated && ["/dashboard"].includes(pathname)) {
    return <Centered>{children}</Centered>;
  } else {
    if (isAuthenticated) {
      return <MainLayout>{children}</MainLayout>;
    } else {
      return <Empty>{children}</Empty>;
    }
    // return <MainLayout>{children}</MainLayout>;
  }
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.AuthReducer.isAuthenticated,
  };
};

export default connect(mapStateToProps)(Layout);
